import { apiBaseUrl } from "api/api";

/**
 * Public unsubscribe API.
 *
 * Plain fetch rather than securePost, deliberately. The payload-encryption key is
 * compiled into this bundle, so it authenticates nothing; the credential here is
 * the signed token in the link. Using the encrypted client would add ceremony
 * without security and would break the page for a recipient whose client mangles
 * the URL.
 */
export type UnsubscribePreview = {
  maskedEmail: string;
  scope: string;
  purposes: { purpose: string; label: string; description: string; granted: boolean }[];
};

export const previewUnsubscribe = async (token: string) => {
  const response = await fetch(
    `${apiBaseUrl}/api/unsubscribe/preview?token=${encodeURIComponent(token)}`
  );
  return response.json();
};

export const confirmUnsubscribe = async (token: string, purposes: string[] | "ALL") => {
  const response = await fetch(`${apiBaseUrl}/api/unsubscribe/withdraw`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, purposes }),
  });
  return response.json();
};
